import i18next from 'i18next'

export enum POSPaymentStatus {
    all = 'all',
    authorised = 'authorised',
    charged = 'charged',
    declined = 'declined',
    refunded = 'refunded',
    cancelled = 'cancelled',
    chargeback = 'chargeback',
    'chargeback-reversal' = 'chargeback-reversal',
    'second-chargeback-lost' = 'second-chargeback-lost'
}

export const posStatusTabKeys = [
    POSPaymentStatus.all,
    POSPaymentStatus.authorised,
    POSPaymentStatus.charged
]

export const getPortalPosStatuses = () =>
    Object.keys(POSPaymentStatus).map((item) => ({
        label: item ? i18next.t(`enums:posPaymentStatus.${item}`, {defaultValue: item}) : '',
        value: item as POSPaymentStatus
    }))
